// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultSpinner_container__1pCF1","containerVisible":"DefaultSpinner_containerVisible__3-d1K"};